import {
  type DropTargetDropEvent,
  Skeleton,
  useDropTarget,
} from '@affine/component';
import type { AffineDNDData } from '@affine/core/types/dnd';
import { useI18n } from '@affine/i18n';
import { TemplateIcon } from '@blocksuite/icons/rc';

import { NavigationPanelEmptySection } from '../../layouts/empty-section';
import { DropEffect } from '../../tree';
import { templatesRootCanDrop, templatesRootDropEffect } from './dnd';

interface RootEmptyProps {
  onClickCreate?: () => void;
  isLoading?: boolean;
  onDrop?: (data: DropTargetDropEvent<AffineDNDData>) => void;
}

export const RootEmpty = ({
  isLoading,
  onClickCreate,
  onDrop,
}: RootEmptyProps) => {
  const t = useI18n();

  const { dropTargetRef, draggedOverDraggable, draggedOverPosition } =
    useDropTarget<AffineDNDData>(
      () => ({
        data: { at: 'navigation-panel:templates:root' },
        onDrop,
        canDrop: templatesRootCanDrop,
      }),
      [onDrop]
    );

  if (isLoading) {
    return <Skeleton />;
  }

  return (
    <NavigationPanelEmptySection
      ref={dropTargetRef}
      icon={TemplateIcon}
      message={t['com.affine.rootAppSidebar.templates.empty']()}
      messageTestId="slider-bar-templates-empty-message"
      actionText={t[
        'com.affine.rootAppSidebar.templates.empty.new-template-button'
      ]()}
      onActionClick={onClickCreate}
    >
      {draggedOverDraggable && (
        <DropEffect
          position={draggedOverPosition}
          dropEffect={templatesRootDropEffect({
            source: draggedOverDraggable,
            treeInstruction: null,
          })}
        />
      )}
    </NavigationPanelEmptySection>
  );
};
